import { createFeature, createReducer, on } from '@ngrx/store';
import { SharedActions, SharedMessagePayload } from './shared.actions';

export interface SharedState {
  lastMessage: SharedMessagePayload | null;
}

const initialState: SharedState = {
  lastMessage: null,
};

export const sharedFeature = createFeature({
  name: 'shared',
  reducer: createReducer(
    initialState,
    on(SharedActions.resetToInitialState, () => ({ ...initialState })),
    on(SharedActions.showMessage, (state, payload) => ({
      ...state,
      lastMessage: payload,
    })),
  ),
});
